import {
  fetch,
  normalize,
  extractHubURL
} from '../../utils/dataAccess';
import { success as deleteSuccess } from './delete';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'PARTNER_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'PARTNER_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'PARTNER_LIST_SUCCESS', retrieved };
}

export function list(page = 'partners') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'PARTNER_LIST_RESET' });
    dispatch(deleteSuccess(null));
  };
}

export function filter(filtersData) {
  return filterAction('PARTNER_LIST_FILTER', 'partners', filtersData)
}

export function sort(sortData) {
  return sortAction('PARTNER_LIST_SORT', 'partners', sortData)
}
